/** 当前文档结构版本。每次 Work/Page/Layer 结构变更时 +1，并在 migrations/ 下新增迁移函数。 */
export const SCHEMA_VERSION = 1;

/** 设计基准画布，固定不变。 */
export const CANVAS_WIDTH = 375;
export const CANVAS_HEIGHT = 667;

/** 桌面端预览时手机框最大宽度。 */
export const MAX_VIEWPORT_WIDTH = 480;
